import React from "react";

import {
  ArrowLeft,
  ArrowRight,
  Bell,
  CircleHelp,
  LayoutDashboard,
  UsersRound,
  Settings,
  Activity,
  Square,
  CloudOff,
  BatteryWarning,
  SmartphoneCharging,
  FileLock,
  DoorOpen,
  House,
  Columns3,
  Menu,
  CirclePlus,
  Image,
  File,
  CalendarClock,
  Check,
  Pointer,
  PanelTop,
  CaseSensitive,
  Shapes,
  UserRoundPlus,
  ShieldAlert,
  TriangleAlert,
  Router,
  DoorClosed,
  Warehouse,
  UserRoundPen,
  BellElectric,
  SquareActivity,
  SlidersHorizontal,
  Trash,
  SendHorizonal,
  Search,
  Binary,
  Copy,
  Info,
  Ellipsis,
  Download,
  X,
  MessageSquare,
  BookOpen,
  RefreshCcw,
  Bookmark,
  Loader,
  Eye,
  EyeOff,
  Globe,
  Plus,
  CircleMinus,
  UserRound,
  MapPin,
  ChevronUp,
  ChevronDown,
  Mail,
  Phone,
  BluetoothOff,
  Radio,
  CircleAlert,
  MonitorCheck,
  History,
  HouseWifi,
  ClipboardList,
  Grid3x3,
  CalendarCheck,
  Map,
  SquareChartGantt,
  MapPinned,
  Key,
  TableProperties,
  Pencil,
  Save,
  MessageSquareMore,
  Layers2,
  RadioTower,
  Palette,
  KeyRound,
  CalendarSync,
  Repeat,
  Headset,
  CirclePower,
  Flag,
  Stethoscope,
  Lightbulb,
  ChevronRight,
  ChevronLeft,
  Building2,
  Clock,
  Shield,
  FileText,
  Wifi,
  Dumbbell,
  Ship,
  NfcIcon,
  Webhook,
  Vault,
  BellOff,
  UserMinus,
} from "lucide-react";

import {
  Checked,
  OpenWarning,
  Auction,
  Unlocked24,
  Unlocked20,
  Loader20,
} from "utilities/iconsNew";

export const iconMap = {
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  notification: Bell,
  help: CircleHelp,
  dashboard: LayoutDashboard,
  users: UsersRound,
  settings: Settings,
  activity: Activity,
  unchecked: Square,
  checked: Checked,
  openWarning: OpenWarning,
  offline: CloudOff,
  auction: Auction,
  unlocked24: Unlocked24,
  batteryWarning: BatteryWarning,
  lowVoltage: SmartphoneCharging,
  fileLock: FileLock,
  openDoor: DoorOpen,
  house: House,
  threeColumns: Columns3,
  menu: Menu,
  circlePlus: CirclePlus,
  image: Image,
  file: File,
  schedule: CalendarClock,
  check: Check,
  pointer: Pointer,
  panelTop: PanelTop,
  text: CaseSensitive,
  shapes: Shapes,
  addUser: UserRoundPlus,
  shieldAlert: ShieldAlert,
  triangleAlert: TriangleAlert,
  unlocked20: Unlocked20,
  remoteAccess: Router,
  closedDoor: DoorClosed,
  storageUnit: Warehouse,
  editUser: UserRoundPen,
  Pencil: Pencil,
  alarm: BellElectric,
  squareActivity: SquareActivity,
  filters: SlidersHorizontal,
  trash: Trash,
  send: SendHorizonal,
  search: Search,
  dailyCode: Binary,
  copy: Copy,
  info: Info,
  ellipsis: Ellipsis,
  download: Download,
  close: X,
  chat: MessageSquare,
  openBook: BookOpen,
  refresh: RefreshCcw,
  myFacility: Bookmark,
  loader: Loader,
  eye: Eye,
  eyeOff: EyeOff,
  globe: Globe,
  plus: Plus,
  circleMinus: CircleMinus,
  user: UserRound,
  mapPin: MapPin,
  chevronUp: ChevronUp,
  chevronDown: ChevronDown,
  mail: Mail,
  phone: Phone,
  bluetoothOff: BluetoothOff,
  gateway: Radio,
  circleAlert: CircleAlert,
  loader20: Loader20,
  monitorCheck: MonitorCheck,
  history: History,
  network: HouseWifi,
  reports: ClipboardList,
  accessCodes: Grid3x3,
  hours: CalendarCheck,
  map: Map,
  fleetMgmt: SquareChartGantt,
  facilities: MapPinned,
  fob: Key,
  training: TableProperties,
  Save: Save,
  MessageSquareMore: MessageSquareMore,
  Plus: Plus,
  Layers2: Layers2,
  RadioTower: RadioTower,
  theme: Palette,
  authentication: KeyRound,
  CalendarSync: CalendarSync,
  Repeat: Repeat,
  support: Headset,
  circlePower: CirclePower,
  flag: Flag,
  stethoscope: Stethoscope,
  lightbulb: Lightbulb,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  building2: Building2,
  clock: Clock,
  shield: Shield,
  fileText: FileText,
  wifi: Wifi,
  dumbbell: Dumbbell,
  ship: Ship,
  nfc: NfcIcon,
  webhook: Webhook,
  vault: Vault,
  bellOff: BellOff,
  bell: Bell,
  userMinus: UserMinus,
};

const AppIcon = ({
    name,
    size = 24,
    fillColor = '',
    className = 'text-[var(--color-gray-800)]',
    stroke = '',
    strokeWidth = 2
}) => {
    const LucideIcon = iconMap[name]; // Get icon from map
    if (!LucideIcon) return null; // Prevent errors for missing icons

    return (
        <LucideIcon
            size={size}
            customstroke={stroke}
            strokeWidth={strokeWidth}
            className={`${fillColor} ${className}`}
        />
    );
};

export default AppIcon;
